<template>
  <v-container>
    <v-layout row align-content-start>
      <v-flex shrink class="mx-3">
        <PassengerSelectField
          type="Adults"
          :v="v"
          desc="12+ yr"
          field="pax_a"
          icon="person"
          :min="1"
          :max="9"
        />
      </v-flex>
      <v-flex shrink class="mr-3">
        <PassengerSelectField
          type="Children"
          :v="v"
          desc="2-11 yr"
          field="pax_c"
          icon="child_care"
          :min="0"
          :max="9"
        />
      </v-flex>
      <v-flex shrink class="mr-3">
        <PassengerSelectField
          type="Infants"
          :v="v"
          desc="0-23 mo"
          field="pax_i"
          icon="child_friendly"
          :min="0"
          :max="9"
        />
      </v-flex>
      <v-spacer></v-spacer>
    </v-layout>
  </v-container>
</template>

<script>
import PassengerSelectField from "@/components/forms/sections/PassengerSelectField.vue";
import { createHelpers } from "vuex-map-fields";
import Shared from "@/mixins/Shared";

const { mapFields } = createHelpers({
  getterType: "getField",
  mutationType: "updateField"
});

export default {
  name: "PassengerSelect",
  props: ["v"],
  computed: {
    ...mapFields([
      "form_fields.pax_a",
      "form_fields.pax_c",
      "form_fields.pax_i",
      "mobileDevice"
    ])
  },
  mixins: [Shared],
  components: { PassengerSelectField },
  data: () => ({
    paxA: [1, 2, 3, 4, 5, 6, 7, 8, 9],
    pax: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
  })
};
</script>
